import './style.scss'
import { useContext, useEffect, useRef, useState } from 'react'
import utility from 'src/utils/utility'
import ApiContext from 'src/provider/API/call-service'
import { AppSpan, AppText, CustomContainer, ScreenContainer } from 'src/style'
import { ServerSideTable } from 'src/component'
import {errorLogsColumns} from 'src/utils/tableLayout'
import {ErrorLogDetails, ErrorLogFilter} from 'src/popup'


const ErrorLogs = () => {
    const {API} = useContext(ApiContext)
    const [data, setData] = useState<any>(null)
    const [errorLogs, setErrorLogs] = useState<any>(null)
    const [selectedErrorLog, setSelectedErrorLog] = useState<any>(null)
    const [view, setView] = useState('')

    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchErrorLogs()
    }, [])

    async function handleFetchErrorLogs (pageNumber = 1, pageSize = 10) {
        const response = await API.getErrorLogs(pageNumber, pageSize, {...filterDataRef.current})
        if (response) {
            setData(response)
            setErrorLogs(response.errorLogs)
        }
    }

    async function handleSelectedRow(data: any) {
        setSelectedErrorLog(data)
        setView('error-log-details')
    }

    return (
        <>
            <ScreenContainer
                leftPadding='2.5' rightPadding='2.5'
                topPadding='1.5' bottomPadding='1.5'
            >
                <CustomContainer>
                    <CustomContainer topMargin="1.5">
                        <AppText textSize="2" fontWeight="600" color="#181D27" bottomMargin="0.7">Error Logs Information</AppText>
                        <AppSpan color="#6F767C">View and manage crendly error logs</AppSpan>
                    </CustomContainer>
                    <CustomContainer topMargin="6">
                        <ServerSideTable
                            tableData={errorLogs}
                            tableColumns={errorLogsColumns} 
                            dataFetchMethod={handleFetchErrorLogs}
                            totalRows={data?.totalCount}
                            customStyle
                            canSearch
                            canFilter
                            canDownload
                            reportFileName='CRENDLY_ERROR_LOGS'
                            onRowClickMethod={handleSelectedRow}
                            filterClickMethod={() => setView('filter')}
                        />
                    </CustomContainer>
                </CustomContainer>
            </ScreenContainer>
            { view === 'error-log-details' &&
                <ErrorLogDetails 
                    close={() => setView('')}
                    data={selectedErrorLog}
                />
            }
            { view === 'filter' &&
                <ErrorLogFilter
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    onApplyFilter={handleFetchErrorLogs} 
                    close={() => setView('')} 
                />
            }
        </>
    )
}

export default utility.routeData('error-logs', 'Error Logs', <ErrorLogs/>)